import React from "react";
import {Box} from "@mui/system";
import CircularProgress from "@mui/material/CircularProgress";
import BasicTable from "../../../../v2/common/BasicTable";

export default function BillingsTable({ rows, columns, totalCount, page, loading, handlePageChange, clickableRow, handleTableRowClick, handleTableCellClick }) {

    if(loading) {
        return(
            <Box sx={styles.emptyContainer}>
                <CircularProgress size={25} sx={{ color: '#003300'}}/>
            </Box>
        )
    }

    return (
        <BasicTable
            rows={rows}
            columns={columns}
            totalCount={totalCount}
            handlePageChange={handlePageChange}
            page={page}
            isPaginationDisabled={loading}
            withPagination={false}
            clickableRow={clickableRow}
            handleTableRowClick={handleTableRowClick}
            handleTableCellClick={handleTableCellClick}
            tableHeadStyle={styles.ellipsis}
        />
    );
}


const styles = {
    ellipsis: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    emptyContainer: {
        backgroundColor: '#FFF',
        border: '1px solid #CED4D4',
        borderRadius: '5px',
        overflow: 'hidden',
        padding: '30px 35px',
    },
}